const assignBox = {
  form: {
    generalForm: {
      header: 'Erweiterte Einstellungen für die Fahrer-Zuweisung',
      actions: {
        saveCheckBox: 'Als Standard speichern',
      },
      formBtns: {
        btnCancel: 'Stornieren',
        btnAssign: 'Zuordnen',
      },
      inputAssignBy: 'Zuweisungstyp',
      inputActualDrivers: 'Real',
      inputVirtualDrivers: 'Virtuell',
    },
    actualForm: {
      information: {
        inputOnlyDrivers: 'Fahrerschichten ignorieren',
        inputMaxShiftsHours: 'Max. Schichtstunden',
        defaultCarLocation: 'Standard-Autostandort',
        inputMaxPrice: 'Höchstpreis',
        inputFillVirtual: 'Nicht-Zugewiesene mit virtuellen Fahrern auffüllen',
        inputMaxTrips: 'Max. Fahrten',
        inputAssignFairly: 'Fair zuweisen',
      },
      validations: {
        maxShifts: {
          require: 'Erforderlich',
          min: 'Mindestens 1',
          max: 'Maximal 24',
        },
        carLocation: {
          require: 'Erforderlich',
        },
        fillVirtual: {
          require: 'Erforderlich',
        },
        maxTrips: {
          require: 'Erforderlich',
        },
        maxPrice: {
          require: 'Erforderlich',
        },
        default: {
          require: 'Erforderlich',
        },
      },
    },
    virtualForm: {
      information: {
        inputUpTo: 'Bis zu',
        inputDrivers: 'Fahrer',
        inputMaxSeats: 'Max. Sitzplätze',
        inputMaxShiftsHours: 'Max. Schichtstunden',
        defaultCarLocation: 'Standard-Autostandort',
        inputAssignFairly: 'Fair zuweisen',
      },
      validations: {
        limitDrivers: {
          require: 'Erforderlich',
        },
        carLocation: {
          require: 'Erforderlich',
        },
        maxShifts: {
          require: 'Erforderlich',
          min: 'Mindestens 1',
          max: 'Maximal 24',
        },
        default: {
          require: 'Erforderlich',
        },
      },
    },
    errorsMessages: {
      updateCar: 'Aktualisierung des Fahrzeugstandorts fehlgeschlagen',
    }
  },
};

export default assignBox;
